import { c as _c } from "react-compiler-runtime";
import { useMemo } from 'react';
import { useProperties } from 'framework-listing-lib/internal/providers/PropertiesProvider';
import { useListingLibData } from 'framework-listing-lib/internal/providers/DataProvider';
import useObjectTypeId from './useObjectTypeId';
export function useCurrentTypeDefinition() {
  "use memo";

  const $ = _c(3);
  const currentObjectTypeId = useObjectTypeId();
  const {
    getTypeDefinition
  } = useListingLibData();
  const {
    typeDefinitionOverride
  } = useProperties();
  let t0;
  bb0: {
    if (typeDefinitionOverride) {
      t0 = typeDefinitionOverride;
      break bb0;
    }
    let t1;
    if ($[0] !== currentObjectTypeId || $[1] !== getTypeDefinition) {
      t1 = getTypeDefinition(currentObjectTypeId);
      $[0] = currentObjectTypeId;
      $[1] = getTypeDefinition;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    t0 = t1;
  }
  return t0;
}
export function useTypeDefinition(t0) {
  "use memo";

  const $ = _c(5);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {
      objectTypeId: undefined
    } : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    objectTypeId
  } = t1;
  const currentTypeDefinition = useCurrentTypeDefinition();
  const {
    getTypeDefinition
  } = useListingLibData();
  const currentObjectTypeId = useObjectTypeId();
  let t2;
  bb0: {
    if (!objectTypeId || objectTypeId === currentObjectTypeId) {
      t2 = currentTypeDefinition;
      break bb0;
    }
    let t3;
    if ($[2] !== getTypeDefinition || $[3] !== objectTypeId) {
      t3 = getTypeDefinition(objectTypeId);
      $[2] = getTypeDefinition;
      $[3] = objectTypeId;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = t3;
  }
  return t2;
}
export function useCurrentTypeDefinitionName() {
  "use memo";

  const currentTypeDefinition = useCurrentTypeDefinition();
  return currentTypeDefinition ? currentTypeDefinition.fullyQualifiedName : undefined;
}